import React, { useEffect, useState } from "react";
import axios from "axios";
import { alert_error } from "../../AppContext.js";

const MoneyListAdmin = () => {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [meta, setMeta] = useState({
    count: 0,
    has_createdate: false,
    has_key_money_ok: false,
    has_money: false,
    message: "",
    status: "",
  });

  const loadMoneyListData = async () => {
    const response = await axios.get("https://nginx.hust.media/go/service/money_list");
    const payload = response?.data || {};
    setRows(Array.isArray(payload.list) ? payload.list : []);
    setMeta({
      count: Number(payload.count) || 0,
      has_createdate: Boolean(payload.has_createdate),
      has_key_money_ok: Boolean(payload.has_key_money_ok),
      has_money: Boolean(payload.has_money),
      message: payload.message || "",
      status: String(payload.status || ""),
    });
  };

  const fetchMoneyList = async () => {
    setLoading(true);
    try {
      await loadMoneyListData();
    } catch (error) {
      alert_error(error);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  const handleReload = async () => {
    setLoading(true);
    try {
      await axios.get("https://nginx.hust.media/go/service/money_update");
      await loadMoneyListData();
    } catch (error) {
      alert_error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMoneyList();
  }, []);

  const formatMoneyParts = (value) => {
    if (value === null || value === undefined || value === "") return null;

    const raw = String(value).trim();
    if (!raw || raw === "-") return null;

    const isNegative = raw.startsWith("-");
    const unsignedRaw = isNegative ? raw.slice(1) : raw;

    const [integerRaw, decimalRaw] = unsignedRaw.split(".");
    const normalizedInteger = (integerRaw || "0").replace(/\D/g, "") || "0";
    const integerWithDots = normalizedInteger.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    const integerPart = `${isNegative ? "-" : ""}${integerWithDots}`;
    const decimalPart = typeof decimalRaw === "string" && decimalRaw.length > 0 ? `,${decimalRaw}` : "";
    return { integerPart, decimalPart };
  };

  return (
    <div className="card-body mx-2 my-2 p-3 sm:p-4 rounded-xl border border-slate-200 bg-gradient-to-br from-sky-50 via-white to-rose-50 shadow-sm">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-3">
        <h2 className="text-2xl font-bold m-0 text-slate-800">Service Money List</h2>
        <button
          onClick={handleReload}
          type="button"
          className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-1.5 px-3 rounded-lg w-auto transition-colors text-sm sm:text-base self-start"
        >
          {loading ? "Loading..." : "Reload"}
        </button>
      </div>

      <div className="mb-4 flex flex-wrap gap-2 text-xs sm:text-sm">
        <span className="px-2 py-1 rounded-full bg-slate-100 text-slate-700">
          Status: <b>{meta.status || "-"}</b>
        </span>
        <span className="px-2 py-1 rounded-full bg-slate-100 text-slate-700">
          Message: <b>{meta.message || "-"}</b>
        </span>
        <span className="px-2 py-1 rounded-full bg-slate-100 text-slate-700">
          Count: <b>{meta.count}</b>
        </span>
        <span className="px-2 py-1 rounded-full bg-slate-100 text-slate-700">
          has_createdate: <b>{String(meta.has_createdate)}</b>
        </span>
        <span className="px-2 py-1 rounded-full bg-slate-100 text-slate-700">
          has_key_money_ok: <b>{String(meta.has_key_money_ok)}</b>
        </span>
        <span className="px-2 py-1 rounded-full bg-slate-100 text-slate-700">
          has_money: <b>{String(meta.has_money)}</b>
        </span>
      </div>

      <div className="table-responsive-sm rounded-lg border border-slate-200 bg-white">
        <table className="w-full table-fixed border-collapse text-sm sm:text-base">
          <thead className="bg-slate-100 text-sm sm:text-base">
            <tr>
              <th className="border text-center py-2 px-2 w-[12%]">ID</th>
              <th className="border text-left py-2 px-2 w-[48%]">Website</th>
              <th className="border text-center py-2 px-1 w-[40%] leading-tight">Money OK</th>
            </tr>
          </thead>
          <tbody className="text-base">
            {rows.map((row) => (
              <tr key={row.id} className="odd:bg-white even:bg-slate-50 hover:bg-sky-50">
                <td className="border text-center py-2 px-2 leading-tight">{row.id}</td>
                <td className="border py-2 px-2 leading-tight">
                  <a
                    href={row.website}
                    target="_blank"
                    rel="noreferrer"
                    className="block w-full text-blue-600 hover:text-blue-700 underline break-all"
                    style={{
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }}
                    title={row.website}
                  >
                    {row.website}
                  </a>
                </td>
                <td className="border text-center py-2 px-1 leading-tight">
                  {(() => {
                    const parts = formatMoneyParts(row.key_money_ok);
                    if (!parts) return "-";
                    return (
                      <>
                        <span className="text-violet-800 font-semibold">{parts.integerPart}</span>
                        <span className="text-emerald-600 font-medium">{parts.decimalPart}</span>
                      </>
                    );
                  })()}
                </td>
              </tr>
            ))}
            {!loading && rows.length === 0 && (
              <tr>
                <td className="border text-center py-3 text-slate-500" colSpan={3}>
                  No data
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MoneyListAdmin;
